module.exports = __webpack_public_path__ + "media/images/pen-a2833648ed01be0199080d26940d196d.svg";